// extracted by mini-css-extract-plugin
export default {"overlay":"ConvertToCollectionModal_overlay__S1ndb","bottom-bar":"ConvertToCollectionModal_bottom-bar__PeAjN","bottomBar":"ConvertToCollectionModal_bottom-bar__PeAjN"};